<template>
  <FileStyleCard class="personal">
    <sdCards headless>
      <img :src="data.thumb" alt="image" />
      <h4 :style="{ marginTop: '16px' }">
        <span>{{ data.name }}</span>
        <!-- <Dragger /> -->
      </h4>
      <!-- <div class="d-flex">
        <p class="title">type:</p>
        <span>{{ data.type }}</span>
      </div> -->
      <!-- <div class="d-flex">
        <p class="title">size:</p>
        <span>{{ fileSize(data.size) }}</span>
      </div> -->
      <div class="actions">
        <span>
          <a @click="() => onHandleDelete()" to="#">
            <sdFeatherIcons type="trash-2" size="16" />
          </a>
        </span>
        <span>
          <sdFeatherIcons class="handle" type="move" />
        </span>
      </div>
    </sdCards>
  </FileStyleCard>
</template>
<script>
import PropTypes from 'vue-types';
import { FileStyleCard, Bullet } from './style';
import { fileSize } from '@/utility/utility';

const FileCard = {
  name: 'FileCard',
  props: {
    data: PropTypes.object,
  },
  emits: ['remove'],
  components: { FileStyleCard, Bullet },
  setup(props, { emit }) {
    const onHandleDelete = () => {
      emit('remove', props.data.id);
    };

    return {
      onHandleDelete,
      fileSize,
    };
  },
};

export default FileCard;
</script>
